import { WinModalAction, WinModalGame } from '@core/constants/win-modal.constants';

export interface WinModalButton {
  action: WinModalAction;
  /** Label while the countdown is running; `{n}` = seconds left. Equals idleLabel for the non-auto button. */
  label: string;
  /** Label once the countdown is stopped (after an action started / failed). */
  idleLabel: string;
  style: 'primary' | 'blue';
}

export interface WinModalGameConfig {
  /** Left button, `button--style-primary`. Never auto-fired. */
  first: WinModalButton;
  /** Right button, `button--style-blue`. Auto-fired when the countdown reaches 0. */
  auto: WinModalButton;
  /**
   * When `true`: skins grid is selectable, "Select All" checkbox and selection
   * info footer are shown, and button labels use "Selected" variants.
   * When `false` (all games currently): acts on all skins, no selection UI.
   * Flip per-game to enable the selection variant.
   */
  selectable: boolean;
}

export const WIN_MODAL_GAME_CONFIG: Record<WinModalGame, WinModalGameConfig> = {
  king: {
    selectable: false,
    first: { action: 'redeposit', label: 'Deposit All', idleLabel: 'Deposit All', style: 'primary' },
    auto: { action: 'withdraw', label: 'Withdraw All in: {n}', idleLabel: 'Withdraw All', style: 'blue' },
  },
  jackpot: {
    selectable: false,
    first: { action: 'redeposit', label: 'Deposit All', idleLabel: 'Deposit All', style: 'primary' },
    auto: { action: 'withdraw', label: 'Withdraw All in: {n}', idleLabel: 'Withdraw All', style: 'blue' },
  },
  upgrader: {
    selectable: false,
    first: { action: 'withdraw', label: 'Withdraw', idleLabel: 'Withdraw', style: 'primary' },
    auto: { action: 'sell', label: 'Sell in: {n}', idleLabel: 'Sell', style: 'blue' },
  },
};
